const getMappedHTML = (rootState) => rootState.ws.view.mappedHTML;

export default getMappedHTML;
